<script setup>
import { useStorage } from '@vueuse/core'

const isDebugging = useStorage('debug', false)
</script>

<template>
	<div v-if="isDebugging">
		<slot />
	</div>
</template>
